module.exports = __webpack_public_path__ + "34bcda9f94cb994df5a042d15d96a9e5.svg";